import { render } from "./gmdetail.vue?vue&type=template&id=15547baa&scoped=true"
import script from "./gmdetail.vue?vue&type=script&lang=js"
export * from "./gmdetail.vue?vue&type=script&lang=js"

import "./gmdetail.vue?vue&type=style&index=0&id=15547baa&lang=scss&scoped=true"
import "./gmdetail.vue?vue&type=style&index=1&id=15547baa&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15547baa"]])

export default __exports__